var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import * as BetType from '../../../constants/BetType';
import { operationTypes } from "../../../constants/constants";
var messages = defineMessages({
    title: {
        id: 'member-area.operation_type_1',
        defaultMessage: 'Ставка'
    },
    looseToWinAccumulator: {
        id: 'bet_type.looseToWinAccumulator',
        defaultMessage: 'Антиэкспресс'
    },
    accumulator: {
        id: 'bet_type.accumulator',
        defaultMessage: 'Экспресс'
    },
    type_stake: {
        id: 'member-area.operation_type_1',
        defaultMessage: 'Ставка'
    },
    type_result: {
        id: 'member-area.operation_type_2',
        defaultMessage: 'Результат'
    }
});
var MultiBet = function (props) {
    var operationsData = props.operationsData, type = props.type, operationType = props.operationType;
    var stakeId = operationsData.StakeId;
    var msg = type === BetType.EXPRESS ? _jsx(FormattedMessage, __assign({}, messages.accumulator)) : _jsx(FormattedMessage, __assign({}, messages.looseToWinAccumulator));
    var typeCls = operationType === operationTypes.STAKE ? 'stake-history-type stake-history-type--stake' : 'stake-history-type stake-history-type--payment';
    var msg2 = operationType === operationTypes.STAKE ? _jsx(FormattedMessage, __assign({}, messages.type_stake)) : _jsx(FormattedMessage, __assign({}, messages.type_result));
    return [
        _jsx("div", __assign({ className: 'header' }, { children: _jsxs("div", __assign({ className: 'title' }, { children: [_jsx(FormattedMessage, __assign({}, messages.title)), " \u2116 ", stakeId] })) }), '1'),
        _jsxs("div", __assign({ className: 'info' }, { children: [msg, _jsx("span", __assign({ className: typeCls }, { children: msg2 }))] }), '2')
    ];
};
MultiBet.propTypes = {
    operationsData: PropTypes.object.isRequired,
    type: PropTypes.number.isRequired
};
export default MultiBet;



// WEBPACK FOOTER //
// ./src/components/account-history/headers/IsMultiBet.jsx